module.exports = __webpack_public_path__ + "img/phone_1.0ff9bcc6.webp";